if (!customElements.get("recipient-form")) {
    customElements.define(
        "recipient-form",
        class RecipientForm extends HTMLElement {
            constructor() {
                super();
                    (this.checkbox = this.querySelector(
                        "[data-recipient-form-checkbox]",
                    )),
                    (this.timezoneInput = this.querySelector(
                        "[data-recipient-form-timezone-input]",
                    )),
                    (this.inputs = this.querySelectorAll(
                        "[data-recipient-form-input], [data-recipient-form-timezone-input]",
                    )),
                    (this.fields = this.querySelector(
                        "[data-recipient-form-fields]",
                    )),
                    (this.timezoneInput.value = new Date().getTimezoneOffset());
            }
            connectedCallback() {
                this.addEventListener("change", this.handleChange);
            }
            disconnectedCallback() {
                this.removeEventListener("change", this.handleChange);
            }
            handleChange() {
                let t = this.checkbox.checked;
                this.updateMaxHeight(t),
                    this.updateInputDisable(!t),
                    t || this.clearInputs();
            }
            clearInputs() {
                this.inputs.forEach((t) => {
                    t.value = "";
                });
            }
            updateInputDisable(t) {
                this.inputs.forEach((i) => {
                    i.disabled = t;
                });
            }
            reset() {
                (this.checkbox.checked = !1), this.clearInputs();
            }
            updateMaxHeight(t) {
                if (!this.fields) return;
                let i = t ? this.fields.scrollHeight : 0;
                this.fields.style.maxHeight = `${i}px`;
            }
            displayErrorMessage(title, body) {
                this.clearErrorMessage();
                this.errorMessageWrapper.hidden = false;
                if (typeof body === "object") {
                    this.errorMessage.innerText = this.defaultErrorHeader;
                    return Object.entries(body).forEach(([key, value]) => {
                        const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
                        const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
                        const message = `${value.join(", ")}`;
                        const errorMessageElement = this.querySelector(
                            `#${errorMessageId}`,
                        );
                        const errorTextElement =
                            errorMessageElement?.querySelector(
                                ".error-message",
                            );
                        if (!errorTextElement) return;

                        if (this.errorMessageList) {
                            this.errorMessageList.appendChild(
                                this.createErrorListItem(
                                    fieldSelector,
                                    message,
                                ),
                            );
                        }

                        errorTextElement.innerText = `${message}.`;
                        errorMessageElement.classList.remove("hidden");

                        const inputElement = this[`${key}Input`];
                        if (!inputElement) return;

                        inputElement.setAttribute("aria-invalid", true);
                        inputElement.setAttribute(
                            "aria-describedby",
                            errorMessageId,
                        );
                    });
                }

                this.errorMessage.innerText = body;
            }

            createErrorListItem(target, message) {
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.setAttribute("href", target);
                a.innerText = message;
                li.appendChild(a);
                li.className = "error-message";
                return li;
            }

            clearErrorMessage() {
                this.errorMessageWrapper.hidden = true;

                if (this.errorMessageList) this.errorMessageList.innerHTML = "";

                this.querySelectorAll(
                    ".recipient-fields .form__message",
                ).forEach((field) => {
                    field.classList.add("hidden");
                    const textField = field.querySelector(".error-message");
                    if (textField) textField.innerText = "";
                });

                [
                    this.emailInput,
                    this.messageInput,
                    this.nameInput,
                    this.sendonInput,
                ].forEach((inputElement) => {
                    inputElement.setAttribute("aria-invalid", false);
                    inputElement.removeAttribute("aria-describedby");
                });
            }

            resetRecipientForm() {
                if (this.checkboxInput.checked) {
                    this.checkboxInput.checked = false;
                    this.clearInputFields();
                    this.clearErrorMessage();
                }
            }
        },
    );
}
